// Beta gate for the native image upload/crop flow (see docs/features/beaker-native-image-upload.md).
// Applies to all image fields — no per-field opt-in.
const COOKIE_NAME = 'nativeUploadBeta';

export function isNativeUploadBetaEnabled() {
  return document.cookie
    .split('; ')
    .some((entry) => entry === `${COOKIE_NAME}=1`);
}

// Lets a link like /#/break/123/edit?nativeUploadBeta=1 (or =0 to opt back out)
// turn the cookie on/off, so the flag can be shared without a settings UI.
export function bootstrapNativeUploadBetaFromQueryParam() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has(COOKIE_NAME)) {
    return;
  }

  const enabled = params.get(COOKIE_NAME) !== '0';
  const oneYear = 60 * 60 * 24 * 365;
  document.cookie = enabled
    ? `${COOKIE_NAME}=1; path=/; max-age=${oneYear}`
    : `${COOKIE_NAME}=0; path=/; max-age=0`;
}



// WEBPACK FOOTER //
// ./public/utils/nativeUploadBeta.js